export type ResultVariant = 'success' | 'failure';
export type ResultSubject = 'boleto' | 'pix';

export interface ResultCopy {
  title: string;
  message: string;
  highlight: string;
}

interface SubjectLabel {
  label: string;
  titleCase: string;
}

const SUBJECT_LABEL: Record<ResultSubject, SubjectLabel> = {
  boleto: { label: 'boleto', titleCase: 'Boleto' },
  pix: { label: 'código Pix', titleCase: 'Código Pix' },
};

const FAILURE_MESSAGE =
  'Não conseguimos confirmar a origem desta cobrança em nosso sistema. Se possível, recomendamos que confirme em um canal de atendimento antes de realizar o pagamento.';
const FAILURE_HIGHLIGHT = 'confirme em um canal de atendimento';

export const getReportWhatsAppMessage = (subject: ResultSubject): string => {
  const { label } = SUBJECT_LABEL[subject];
  return `Olá! Testei no validador de cobranças um ${label} que recebi, e o sistema indicou que ele não foi gerado pela CUB. Poderiam me orientar sobre os próximos passos?`;
};

export const getResultCopy = (variant: ResultVariant, subject: ResultSubject): ResultCopy => {
  const { label, titleCase } = SUBJECT_LABEL[subject];

  if (variant === 'success') {
    return {
      title: `${titleCase} com origem CUB`,
      message: `Boa notícia! O ${label} consultado tem origem na CUB e seu pagamento é seguro.`,
      highlight: 'seguro',
    };
  }

  return {
    title: `Este ${label} NÃO foi gerado pela CUB`,
    message: FAILURE_MESSAGE,
    highlight: FAILURE_HIGHLIGHT,
  };
};
